import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'
import PhotoGallery from '../ui/PhotoGallery'
import FloatingLoveMessages from '../ui/FloatingLoveMessages'

export default function PhotoGallerySection() {
  return (
    <SectionWrapper
      id="photos"
      gradient="from-dark-primary via-primary-pink/5 to-dark-primary"
    >
      {/* Floating Love Messages Background */}
      <FloatingLoveMessages count={10} />

      {/* Header */}
      <motion.div className="text-center mb-8 sm:mb-12 lg:mb-16 px-4 relative z-10">
        <motion.span
          className="tag-pill mb-3 sm:mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>📸</span>
          <span>Nos Souvenirs</span>
        </motion.span>

        <motion.h2
          className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-serif font-bold gradient-text mb-2 sm:mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Moments Capturés
        </motion.h2>

        <motion.p
          className="text-sm sm:text-base lg:text-lg text-light-pink-100/70 px-4 max-w-xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          Chaque photo raconte un chapitre de notre histoire d'amour
        </motion.p>
      </motion.div>

      {/* Photo Gallery */}
      <div className="relative z-10">
        <PhotoGallery />
      </div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-8 sm:mt-12 lg:mt-16 max-w-2xl mx-auto px-4 relative z-10"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "500+ photos de souvenirs
          <br />
          Chaque image, un trésor de notre amour"
        </p>
        <footer className="mt-3 sm:mt-4 text-primary-pink text-xs sm:text-sm">
          — Notre Galerie
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
